const text = `
# Partneřské školy a školky:

Chceme vytvářet dlouhodobou komunitu a šířit informace dále, proto chceme oslovit základní a mateřské školy a mateřská centra jako partnery konference. Naši partneři budou mít přístup ke všem informacím, materiálům, videozáznamu z konference. Zároveň jim můžeme nabídnout zajímavé workshopy o výchově a vzdělávání, které zorganizujeme přímo u nich, či nabídnout výhodnější vstupné na konferenci pro jejich zaměstnance.

Naši partneři budou viditelně označeni nálepkou na dveřích a plakátem konference.

Jestliže máte zájem se stát partneřskou školou, či školkou, napište nám na [info@vychovakzivotu.com](mailto:info@vychovakzivotu.com) a rádi Vám sdělíme bližší informace.
`
const sponsors = [
  {
    name: 'Materská škola Cabanova',
    logo: require('../resources/sponsors/ms_cabanova.jpg'),
    link: 'https://mscabanova.sk/',
  },
  {
    name: 'Základní škola Husova',
    logo: require('../resources/sponsors/zs_husova.png'),
    link: 'http://zshusovabrno.cz/',
  },
  {
    name: 'Súkromná základná škola Felix',
    logo: require('../resources/sponsors/felix.jpg'),
    link: 'http://www.skolafelix.sk/',
  },
  {
    name: 'Jesličky pro dětičky',
    logo: require('../resources/sponsors/malousci.png'),
    link: 'http://malousci.cz/',
  },
  {
    name: 'Mateřská škola',
    logo: require('../resources/sponsors/kvetinka.jpg'),
    link: 'http://skolka-trinec.cz/clanky/ms-nerudova/',
  },
  {
    name: 'scio škola',
    logo: require('../resources/sponsors/scio.png'),
    link: 'https://brno.scioskola.cz/',
  },
  {
    name: 'Detské súkromné zariadenie',
    logo: require('../resources/sponsors/svetielko.png'),
    link: 'http://www.detske-svetielko.sk/jasle/',
  },
  {
    name: 'Súkromná materská škola',
    logo: require('../resources/sponsors/sukromna_materska_skola.jpg'),
    link: 'http://www.detske-svetielko.sk/skolka/',
  },
  {
    name: 'Súkromná základná škola',
    logo: require('../resources/sponsors/zs_nova_dubnica.png'),
    link: 'http://szsndca.sk/',
  },
  {
    name: 'Súkromná ZŠ s MŠ',
    logo: require('../resources/sponsors/montessori.png'),
    link: 'http://montessori.sk/',
  },
  {
    name: 'Primaskolka',
    logo: require('../resources/sponsors/primaskolka.jpg'),
    link: 'http://www.primaskolka.sk/',
  },
  {
    name: 'Sluníčko dětem',
    logo: require('../resources/sponsors/slunickodetem.png'),
    link: 'http://www.slunicko-detem.cz/',
  },
  {
    name: 'MŠ a ZŠ Sluníčko',
    logo: require('../resources/sponsors/slunicko_montessori.jpg'),
    link: 'http://www.slunicko-montessori.cz/',
  },
  {
    name: 'Mateřské centrum',
    logo: require('../resources/sponsors/mcsedmikraska.png'),
    link: 'https://www.mcsedmikraskabrno.cz/',
  },
  {
    name: 'ZŠ Gajdošova',
    logo: require('../resources/sponsors/zs-gajdosova.png'),
    link: 'http://www.zsgajdosova.cz/',
  },
  {
    name: 'ZŠ Antonínská Brno',
    logo: require('../resources/sponsors/zs-antoninska.png'),
    link: 'http://www.zsantoninska.cz/',
  },
  {
    name: 'Rodinné Centrum Kramárik Bratislava',
    logo: require('../resources/sponsors/rodinne-centrum-kramarik.png'),
    link: 'http://www.rckramarik.sk/',
  },
  {
    name: 'Škola u Filipa',
    logo: require('../resources/sponsors/skola-u-filipa.png'),
    link: 'http://www.skolaufilipa.sk/',
  },
  {
    name: 'ZŠ Donum Felix Kladno',
    logo: require('../resources/sponsors/zs-donum-felix.png'),
    link: 'http://donumfelix.cz/',
  },
]

export default {
  text,
  sponsors,
}



// WEBPACK FOOTER //
// ./src/content/devdata/sponsors/schoolPartners.js